import { GetIdentificationEnvSivResponse } from "@/app/api/identification-env-siv/route";
import { getIdentificationEnvSivRequestSchema } from "@/lib/schemas/identification-env-siv";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const IDENTIFICATION_ENV_SIV_ENDPOINT = "/api/identification-env-siv";

export const invalidateIdentificationEnvSivQuery = createInvalidateQuery(
  IDENTIFICATION_ENV_SIV_ENDPOINT,
);

export const useIdentificationEnvSivQuery =
  createQueryHook<GetIdentificationEnvSivResponse>(
    IDENTIFICATION_ENV_SIV_ENDPOINT,
    getIdentificationEnvSivRequestSchema,
  );
